import { Stack, Typography } from '@mui/material';
import { type FC } from 'react';
import { ControlledSlackChannelSelect } from '../../../components/ControlledSlackChannelSelect';
import { useSlackChannelOptions } from '../hooks/useSlackChannelOptions';
import type {
  SlackConfigurationControl,
  SlackConfigurationFormValues,
} from '../SlackConfigurationFormSchema';

type ChannelConfigurationSectionProps = {
  control: SlackConfigurationControl;
  defaultValues: Partial<SlackConfigurationFormValues>;
};

export const ChannelConfigurationSection: FC<ChannelConfigurationSectionProps> = ({
  control,
  defaultValues,
}) => {
  const { channels, isLoading } = useSlackChannelOptions();

  return (
    <Stack direction="column" sx={{
      gap: 2
    }}>
      <Typography variant="h6">Channel Configuration</Typography>
      <Typography variant="body2" sx={{
        color: "text.secondary"
      }}>
        Select the Slack channel where notifications will be sent.
      </Typography>
      <ControlledSlackChannelSelect
        name="channelId"
        control={control}
        label="Slack Channel"
        placeholder="Select a channel for notifications"
        defaultValue={defaultValues.channelId ?? ''}
        channels={channels}
        isLoading={isLoading}
      />
    </Stack>
  );
}; 